import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QltsUserController from "../../../../services/qlts/qlts-user-controller";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getSchoolId, getSchoolYear} from "../../../../utils/authority";
import StudentController from "../../../../services/system/student/student-controller";
import GradeManager from "../../../../components/Grade";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import CLBRegisterController from "../../../../services/system/clb-register/clb-register-controller";
import TableHeader from "../../../../components/TableHeader";
import moment from "moment";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {createSearchParams} from "react-router-dom";
import Pagination from "../../../../components/Pagination";
import ServiceOtherController from "../../../../services/system/service-other/service-other-controller";
import ServiceOtherRegisterController
    from "../../../../services/system/service-other-register/service-other-register-controller";
import Utils from "../../../../utils/utils";

class ModalEditStudentToService extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listServiceNumber: {},
            listServiceNote: {},
            otherRegisterItemResList: [],
            content: "",
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên sản phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "endDate",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Số lượng mua",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Chú thích",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            console.log(nextProps.itemSelected)
            this.setState(nextProps.itemSelected)
            this.setState({
                serviceOtherId: nextProps.serviceOtherId
            })
        }
    }
    componentWillMount() {
    }
    addStudent = () => {
        let payload = {
            id: this.state.id,
            serviceOtherId: this.state.serviceOtherId,
            studentId: this.state.studentLiteRes?.id,
            content: this.state.content,
            registerItemList: this.state.otherRegisterItemResList,
            yearId: parseInt(getSchoolYear())
        }
        console.log(payload)
        ServiceOtherRegisterController.edit(payload, res => {
            if (res.success) {
                toast.success("Sửa dịch vụ cho học sinh thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.warning(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    render() {
        let {gradeId, otherRegisterItemResList, header} = this.state
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered modal-normal">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Sửa đăng ký sản phẩm của học sinh</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0">Lớp</label>
                                    <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0"><b>{this.state.studentLiteRes?.currentClassRoomRes?.name}</b></label>
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-2 label-item pl-0">Học sinh</label>
                                    <label className="col-xs-12 col-sm-12 col-md-2 label-item pl-0"><b>{this.state.studentLiteRes?.fullName}</b></label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-2 label-item pl-0">Ghi chú</label>
                                    <input
                                        placeholder="Ghi chú"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.content}
                                        onChange={(event) => {
                                            this.setState({
                                                content: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0"><b>Danh sách sản phẩm thuộc dịch vụ</b></label>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.otherRegisterItemResList ||
                                                this.state.otherRegisterItemResList.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {otherRegisterItemResList &&
                                                    otherRegisterItemResList.length > 0 &&
                                                    otherRegisterItemResList?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.price)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {row.tax}%
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                <input
                                                                    placeholder="Số lượng mua"
                                                                    type="number"
                                                                    className="form-control shadow-none"
                                                                    value={this.state.otherRegisterItemResList[index].number}
                                                                    onChange={(event) => {
                                                                        this.state.otherRegisterItemResList[index].number = event.target.value
                                                                        this.setState(this.state.otherRegisterItemResList)
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <input
                                                                    placeholder="Ghi chú: Size, màu,.."
                                                                    maxLength={255}
                                                                    type="text"
                                                                    className="form-control shadow-none"
                                                                    value={this.state.otherRegisterItemResList[index].note}
                                                                    onChange={(event) => {
                                                                        this.state.otherRegisterItemResList[index].note = event.target.value
                                                                        this.setState(this.state.otherRegisterItemResList)
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.addStudent()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalEditStudentToService
